import React, { useState, useEffect } from 'react';
import api from '../../api/auth';

const StudentMessages = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await api.get('/messages', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setMessages(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error('Erreur messages:', err);
      setMessages([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 lg:p-8 bg-white min-h-screen">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-[#0A0A0A]">💬 Messages</h1>
        <p className="text-gray-500 mt-1">Communique avec tes professeurs et l'administration</p>
      </div>

      {loading ? (
        <div className="text-center py-20 text-gray-500">Chargement...</div>
      ) : messages.length === 0 ? (
        <div className="bg-white rounded-2xl border border-gray-100 p-12 text-center">
          <p className="text-5xl mb-3">📭</p>
          <p className="text-lg font-bold text-[#0A0A0A] mb-2">Aucun message</p>
          <p className="text-sm text-gray-500">Tes messages apparaîtront ici.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {messages.map((msg) => (
            <div key={msg.id} className="bg-white rounded-2xl border border-gray-100 p-5 hover:shadow-md transition">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-full bg-[#F39C12] flex items-center justify-center text-white font-bold flex-shrink-0">
                  {(msg.sender_name || 'U').charAt(0).toUpperCase()}
                </div>
                <div className="flex-1">
                  <p className="font-bold text-[#0A0A0A]">{msg.sender_name || 'Expéditeur'}</p>
                  <p className="font-medium text-sm text-gray-700 mt-1">{msg.subject || 'Sans objet'}</p>
                  <p className="text-sm text-gray-500 mt-1">{msg.body || msg.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StudentMessages;